import { mainConfig } from "../data/main";

export const downloadFile = async (url: string, filename: string) => {
  const a = document.createElement("a");
  a.href = `${mainConfig.url}/files/${url}/${filename}`;
  a.download = filename || "";
  document.body.appendChild(a);
  a.target = "blank";
  a.click();
  document.body.removeChild(a);
};
